// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Oswald_f4861c', '__Oswald_Fallback_f4861c'","fontStyle":"normal"},"className":"__className_f4861c"};